import React from 'react'
import Avatar from "@mui/material/Avatar";
function ScheduleMeeting({ currentAgenda,  newProfile, toCandidates, showProfile }) {
  return (
           <div className='w-full h-screen bg-blue-7 md:grid md:justify-items-center md:items-center pl-2 pr-2 pt-12 pb-10 md:pl-56 md:pr-56 md:pb-24 md:pt-10'>
                <div className='justify-items-start w-11/12 -mt-5 mb-6 md:hidden'>
                    {localStorage.getItem("boardName")}
                </div>
                <div className='w-auto h-auto bg-white-1 rounded-md pl-6 pt-8 pr-10 pb-8 md:pl-10 md:pr-10 md:pt-10 md:pb-10'>
                    <div>
                        <img  src='/calendly.png'/>
                    </div>
                    <div className='mt-6 md:mt-4'>
                        <h2 className='md:text-4xl text-2xl font-bold font-Poppins'>Your meeting has been scheduled!</h2>
                    </div>
                    <div className='mt-6 md:mt-4'>
                        <h2 className='md:text-lg text-base font-semibold font-Poppins'>Meeting with recruiting manager for {newProfile?.full_name?.split(' ')[0]}{currentAgenda?.length > 0 ? ` & ${currentAgenda?.length} more` : ``}</h2>
                    </div>
                    <div className="grid grid-cols-12 mt-6 md:mt-4 gap-6">
                      <div className="col-span-6">
                          <span className="text-black-4 font-light font-Poppins ">Date</span>
                          <h2 className="md:text-base text-sm font-semibold mt-2 font-Poppins">{currentAgenda[0]?.meetingDate}</h2>
                      </div>
                      <div className="col-span-6">
                          <span className="text-black-4 font-light font-Poppins">Time</span>
                          <h2 className="md:text-base text-base font-semibold mt-2 font-Poppins">{currentAgenda[0]?.meetingTime.split(' ')[2]} - {currentAgenda[0]?.endMeetingTime}</h2>
                      </div>
                  </div>
                    <div className='mt-6 md:mt-4'>
                        <h2 className='text-base text-[#505050] font-bold font-Poppins'>Candidates Selected</h2>
                    </div>
                    <div className='mt-6 md:mt-4 flex'>
                        <div className='flex flex-wrap justify-start w-full'>   
                            {/* For new candidate */}
                            <div>
                                {/* DP */}
                                <div className='flex justify-center'>
                                    <div style={{backgroundColor: newProfile?.bgColor}} className={`flex items-center justify-center rounded-full w-[60px] h-[60px] hover:border-blue-4 cursor-pointer mb-4 relative`}  onClick={() => showProfile(newProfile?.id)}>
                                        <Avatar alt="Profile" src={newProfile?.emoji_url} className="mt-1" imgProps={ {'style':{'objectFit': 'contain'}}} />
                                        {/* New tag */}
                                        <div className='rounded-md text-sm bg-blue-1 text-center text-white-1 absolute top-0 right-0' style={{width:"27px",height:"12px",textAlign:"center"}} >
                                            <p className='-mt-1' style={{fontSize:"8px"}}>New</p>
                                        </div>
                                    </div>
                                </div>

                                {/* Full name */}
                                <div className={`w-28 text-center text-black-1 text-sm p-1 rounded-sm border-blue-1 bg-white-1 border font-medium`} onClick={() => showProfile(newProfile?.id)}>
                                {newProfile?.full_name?.split(" ")[0]}
                                </div>
                            </div>

                            {currentAgenda?.length && 
                                currentAgenda.slice(0,1).map((profile, index) => (
                                    profile.emoji_url !== newProfile.emoji_url &&
                                    <div key={index} className="">
                                        <div className='flex justify-center'>
                                            <div style={{backgroundColor: profile.bgColor}} className={`w-[60px] h-[60px] flex items-center justify-center rounded-full hover:border-blue-4 cursor-pointer mb-4 ml-2`}  onClick={() => showProfile(profile?.id)}>
                                                <Avatar alt="Profile" src={profile.emoji_url} className="" imgProps={ {'style':{'objectFit': 'contain'}}} />
                                            </div>
                                        </div>
                                        
                                        <div key={index} className={`w-28 text-center text-black-1 text-sm p-1 ml-2 mb-4 rounded-sm border-blue-1 bg-white-1 border font-medium`} onClick={() => showProfile(profile?.id)}>
                                            {profile.full_name?.split(" ")[0]}
                                        </div> 
                                    </div>
                                ))
                            }
                            { currentAgenda.length > 1 && 
                                <div>
                                    {/* DP */}
                                    <div className='flex justify-center'>
                                        <div className={`flex items-center justify-center rounded-full w-[60px] h-[60px] hover:border-blue-4 mb-4 bg-[#FFE7E7]`}>
                                            <Avatar alt="Profile" src="user1.png" className="mt-1"/>
                                        </div>
                                    </div>

                                    {/* Full name */}
                                    <div className={`w-28 text-center text-black-1 text-sm p-1 rounded-sm border-blue-1 bg-white-1 border font-medium ml-2`}>
                                    + {currentAgenda.length - 1} more
                                    </div>
                                </div>
                            }
                        </div>
                      
                    </div>
                 
                    <div className='grid grid-cols-12 mt-6 md:mt-4'>
                        <div className="col-span-5">
                            <button className='bg-pink-1 text-white-1 rounded-sm p-2 w-60'  onClick={() => toCandidates()}>View other candidates</button>        
                        </div>
                    </div>
                </div>
              </div>
  )
}

export default ScheduleMeeting